import React from 'react'
import Hammer from './Hammer'

/*
  Re-usable component to swipe left of right
*/
class Swipable extends React.Component {
  swipe (evt) {
    if(evt.additionalEvent === 'panright') {
      this.direction = 'right'
    } else if(evt.additionalEvent === 'panleft') {
      this.direction = 'left'
    } else {
      // if panning up or down, swiping is ignored
      this.direction = null
    }
  }
  endSwiping () {
    const { onSwipeRight, onSwipeLeft } = this.props
    if(this.direction === 'left') {
      onSwipeLeft()
    } else if(this.direction === 'right') {
      onSwipeRight()
    }
    this.direction = null
  }
  render () {
    return (
      <Hammer
        onPan={this.swipe.bind(this)}
        onPanEnd={this.endSwiping.bind(this)}
      >
        {this.props.children}
      </Hammer>
    )
  }
}

export default Swipable


// WEBPACK FOOTER //
// ./src/components/common/Swipable.js